export default "__VITE_ASSET__0MtHP5Gy__"